// extracted by mini-css-extract-plugin
module.exports = {"footer":"AppFooter_footer__O0b6H","mobile":"AppFooter_mobile__evbfU","desktop":"AppFooter_desktop__rTvA1"};